












































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  toRefs,
  getCurrentInstance,
  ComponentInternalInstance,
  watch,
} from '@vue/composition-api';
import { UsergroupIcon, DeleteIcon, UserIcon, ErrorCircleIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { isDisabledAllAuth, phoneCompose } from '@/renderer/scripts/utils/tools/index';
import { SMH } from '@/renderer/scripts/smh';
import { checkRoleIsAdmin } from '@/renderer/scripts/utils/UserRole';
import { showPhoneOrAccountName } from '@/renderer/components/dialog/AddTransfer/compositions/useTools';

type TableData = {
  list: any[];
  NextMarker: string;
  selectedRowKeys: any[];
  selectedList: any[];
};

export default defineComponent({
  components: {
    UsergroupIcon,
    DeleteIcon,
    UserIcon,
    ErrorCircleIcon,
  },
  props: {
    renderPermissionsList: {
      type: Array,
      default: [],
    },
    roleLoading: {
      type: Boolean,
      default: false,
    },
    // 判断是否可以添加管理员的
    noDisableRoleSelect: {
      type: Boolean,
      default: false,
    },
    // 是否允许管理员设置权限
    canAdminSetRole: {
      type: Boolean,
      default: false,
    },
    // 继承成员是否更多加载
    authMoreData: {
      type: Object,
      default: () => {
        return {
          hasMore: false,
          loading: false,
        };
      },
    },
    checkAll: {
      type: Object,
      default: () => {
        return {
          checked: false,
          t: 0,
        };
      },
    },
  },
  filters: {
    formatTag(tag: number) {
      const map: Record<number, string> = {
        1: i18n_t('继承'),
      };
      return map[tag];
    },
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const renderRoleList = computed(() =>
      (store.getters.roles as SMH.Role[]).filter(role => {
        // 协作空间权限详情不显示操作者和禁止访问角色
        const routeName = vm.$route.name as string;
        if (routeName.includes('collaborationSpace')) {
          return !role.canAuthorize && !isDisabledAllAuth(role);
        }
        if (['teamManagement'].includes(routeName)) {
          // 团队管理页面添加成员不允许授予禁止访问权限
          return !isDisabledAllAuth(role);
        }
        return true;
      }),
    );

    const columns = [
      {
        colKey: 'row-select',
        type: 'multiple',
        width: 21,
        disabled: ({ row }: { row: any }) => row.disabledOperate,
      },
      {
        colKey: 'name',
        title: i18n_t('姓名'),
        className: 'col-project-name',
      },
      {
        colKey: 'action',
        title: i18n_t('操作'),
        className: 'col-project-name',
      },
    ];

    const tableData = reactive<TableData>({
      list: [],
      NextMarker: '',
      selectedRowKeys: [],
      selectedList: [],
    });

    const methods = {
      handleRemoveMember(index: number, item: CoFile.TeamOrMemberItem) {
        context.emit('remove', {
          index,
          item,
        });
      },
      isAdmin(role: string, adminPermission: boolean, userId: string) {
        // 当在团队管理员的界面时，更新团队管理员的界面团队管理员肯定时有权限的
        const routeName = vm.$route.name as string;
        const admin = checkRoleIsAdmin(role, routeName !== 'teamManagement');
        const notMySelfAndHasPermission = adminPermission && userId !== store.getters.userId;
        return admin || notMySelfAndHasPermission;
      },
      handleSelectRows(value: Array<String | Number>, { selectedRowData }: any) {
        tableData.selectedRowKeys = value;
        tableData.selectedList = selectedRowData;
        const selectedAuthList = selectedRowData.map((item: any) => item.uid);
        context.emit('selectChanged', selectedAuthList);
      },
      onScrollY(params: { e: WheelEvent }) {
        const { target } = params.e;
        const { clientHeight, scrollHeight, scrollTop } = target as HTMLElement;
        if (clientHeight + scrollTop >= scrollHeight - 100) {
          if (!props.authMoreData.loading && props.authMoreData.hasMore) {
            context.emit('loadMoreAuthData');
          }
        }
      },
    };

    watch(
      () => props.checkAll,
      val => {
        tableData.selectedRowKeys = [];
        tableData.selectedList = [];
        const selectedAuthList: number[] = [];
        props.renderPermissionsList.forEach((item: any) => {
          if (val.checked && !item.disabledOperate) {
            tableData.selectedRowKeys.push(item.renderKey);
            tableData.selectedList.push(item.renderKey);
            selectedAuthList.push(item.uid);
          }
        });
        context.emit('selectChanged', selectedAuthList);
      },
      { deep: true },
    );

    return {
      phoneCompose,
      columns,
      renderRoleList,
      ...toRefs(tableData),
      ...methods,
      checkRoleIsAdmin,
      showPhoneOrAccountName,
    };
  },
});
